import { PresetArea, PresetObj } from "../api-entities/PresetArea";

/**
 * A latitude/longitude quadrangle described by its four edges.
 */
export type Area = {
	north: number;
	east: number;
	south: number;
	west: number;
};

export type AreaWorking = {
	north?: number;
	east?: number;
	south?: number;
	west?: number;
};

/**
 * Construct a new area object from its API representation.
 */
export const makeAreaObj = (presetArea: PresetArea): PresetObj => ({
	id: presetArea.id,
	name: presetArea.name,
	area: {
		north: parseFloat(presetArea.north),
		west: parseFloat(presetArea.west),
		south: parseFloat(presetArea.south),
		east: parseFloat(presetArea.east)
	}
});
